"use client";

import * as React from "react";
import { Box, Stack, List, ListItem, Typography, ListItemButton, Avatar } from "@mui/material";
import { HeaderNavProps } from "@/components/header/common/types";
import { NavigationType } from "@/components/header/common/header-enums";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowRight";

type MobileSecondaryNavigationItemsProps = {
  secondaryNavItems: HeaderNavProps[];
  setActiveNavigation: (activeNavigation: NavigationType) => void;
  setTertiaryNavItems: (destination: HeaderNavProps[]) => void;
  setTertiaryHeaderLabel: (label: string) => void;
  setTertiaryHeaderLearnMoreUrl: (url: string) => void;
  setTertiaryHeaderViewAllDestinationsUrl: (url: string) => void;
};
export default function MobileSecondaryNavigationItems(props: MobileSecondaryNavigationItemsProps) {
  const { secondaryNavItems, setActiveNavigation, setTertiaryHeaderLabel, setTertiaryHeaderLearnMoreUrl,
    setTertiaryNavItems, setTertiaryHeaderViewAllDestinationsUrl } = props;

  const handleListItemClick = (d: HeaderNavProps) => {
    setTertiaryHeaderLearnMoreUrl(d.fields.learnMoreUrl);
    setTertiaryHeaderViewAllDestinationsUrl(d.fields.viewAllDestinationsUrl);
    setTertiaryHeaderLabel(d.fields.title);
    setTertiaryNavItems(d.fields.subNavList ?? []);
    setActiveNavigation(NavigationType.tertiary);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 998,
        left: 0,
        top: 59,
        height: "100dvh",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "background.default"
      }}
    >
      <List
        sx={{
          overflow: "hidden",
          paddingTop: 0
        }}
      >
        {secondaryNavItems.map((destination: HeaderNavProps) => (
          <ListItem
            key={destination.sys.id}
            component="li"
            data-testid={`secondary-nav-item-${destination.fields.title}`}
            // disableGutters
            sx={{
              padding: 0,
              display: "flex",
              flexDirection: "row"
            }}
          >
            <ListItemButton
              onClick={() => {
                handleListItemClick({ ...destination });
              }}
              data-nav-level="secondary"
              data-nav-label={destination.fields.title}
              sx={{
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                paddingX: "2.4rem",
                paddingY: "2rem"
              }}
            >
              <Stack direction="row" spacing={2} sx={{ width: "100%", alignItems: "center"   }}>
                {destination.fields.icon?.fields.file.url && (
                  <Box>
                    <Avatar
                      sx={{
                        borderRadius: "0px",
                        width: 30,
                        height: 30
                      }}
                      alt={destination.fields.title}
                      src={`https://${destination.fields.icon?.fields.file.url}`}
                    />
                  </Box>
                )}
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "1.4rem",
                      fontWeight: "400",
                      color: "text.secondary"
                    }}
                  >
                    {destination.fields.title}
                  </Typography>
                </Box>
                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: "2.4rem",
                    fontWeight: 600
                  }}
                />
              </Stack>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
